export default "__VITE_ASSET__CR5$lmcF__"